/**
 * Manage Hero w filter UI.
 * 
 */

let
	$window = $(window),
	$myFilterButton = $('.filter-blade__button'),
	$myFilterPanel = $('.filter-blade__panel'),
	$myFilters = $('.filter-blade__filter');

// Initialize filter UI in Hero block.
function initHeroFilterUI() {
	console.log('HERO + FILTER: initHeroFilterUI()');

	$myFilterButton.on('click', function() {
		// On filter button click, open or close filters panel...
		// console.log('FILTER BUTTON CLICK');

		if ($(this).hasClass('open')) {
			$myFilterPanel.slideUp(200);
			// $myFilterPanel.fadeOut(200);
		} else {
			$myFilterPanel.slideDown(200);
			// $myFilterPanel.fadeIn(200);
		}
		$(this).toggleClass('open');
		$myFilterPanel.toggleClass('open');

		// Close panel on click outside.
		var handler = function(event){
			// console.log("CLICK OFF");
			// if the target is a descendent of container do nothing
			if($(event.target).is('.filter-blade__button, .filter-blade__button *, .filter-blade__filter, .filter-blade__filter *')) return;
			
			// remove event handler from document
			$(document).off("click", handler);
			
			// Close panel.
			$myFilterPanel.slideUp(200);
			$myFilterButton.toggleClass('open');
			$myFilterPanel.toggleClass('open');
		};
		
		$(document).on("click", handler);
	});
	
	$myFilters.on('click', function() {
		// On filter click, reload page...
		// console.log('FILTER CLICK');

		if ($(this).hasClass('active')) {
			// If active filter clicked, unfilter page...
			$(this).toggleClass('active');
			var unfiltered_page = '//' + window.location.host + window.location.pathname;
			unfiltered_page = unfiltered_page.replace(/page\/\d+\/?/, '');
			// console.log('FILTER CLICK OFF: '+unfiltered_page);
			window.location.href = unfiltered_page;
		} else {
			// If inactive filter clicked, filter page...
			$myFilters.filter('.active').toggleClass('active');
			$(this).toggleClass('active');
			var my_term = $(this).data('filterSlug');
			var filtered_page = '//' + window.location.host + window.location.pathname + '?filter=' + my_term;
			filtered_page = filtered_page.replace(/page\/\d+\/?/, '');
			// console.log('FILTER CLICK ON: '+filtered_page);
			window.location.href = filtered_page;
		}
	});

	// Populate and pre-select filter menu based on query vars.
	var urlParams;
	(window.onpopstate = function () {
	    var match,
	        pl     = /\+/g,  // Regex for replacing addition symbol with a space
	        search = /([^&=]+)=?([^&]*)/g,
	        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	        query  = window.location.search.substring(1);
	  
	    urlParams = {};
	    while (match = search.exec(query))
	       urlParams[decode(match[1])] = decode(match[2]);
	})();

	if (!jQuery.isEmptyObject(urlParams)) {
		// Save selected filter slug.
		// var activeFilters = urlParams['filter'].split(',');
		var activeFilter = urlParams['filter'];

		// Find filter based on slug and set to .active.
		var $myFilter = $myFilters.filter('[data-filter-slug="'+activeFilter+'"]');
		$myFilter.addClass('active');
	} else {
		$myFilter = $myFilters.filter('[data-filter-slug="all"]');
		$myFilter.addClass('active');
	}
}

 exports.init = function () {
	// console.log('HERO W FILTER: exports.init');
    // Run init methods...

	initHeroFilterUI();
	// initResizeWatcher();
};